import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MdHome, MdChevronRight } from 'react-icons/md';
import '../../styles/shared/Breadcrumb.css';

const routeLabels: Record<string, string> = {
  products: 'Products',
  categories: 'Categories',
  cart: 'Cart',
  checkout: 'Checkout',
  wishlist: 'Wishlist',
  orders: 'My Orders',
  invoices: 'My Invoices',
  'report-issue': 'Report an Issue',
  returns: 'Returns & Disputes',
  profile: 'Profile',
  about: 'About Us',
  contact: 'Contact Us',
};

interface Props {
  extra?: string;
}

const Breadcrumb: React.FC<Props> = ({ extra }) => {
  const { pathname } = useLocation();
  const segments = pathname.split('/').filter(Boolean);

  const crumbs: { label: string; to: string }[] = [];

  segments.forEach((seg, i) => {
    const path = '/' + segments.slice(0, i + 1).join('/');
    const label = routeLabels[seg] || seg.charAt(0).toUpperCase() + seg.slice(1).replace(/-/g, ' ');
    crumbs.push({ label, to: path });
  });

  return (
    <nav className="breadcrumb">
      <div className="breadcrumb__inner">
        <Link to="/" className="breadcrumb__home">
          <MdHome />
          <span>Home</span>
        </Link>
        {crumbs.map((crumb, i) => {
          const isLast = i === crumbs.length - 1 && !extra;
          return (
            <React.Fragment key={crumb.to}>
              <MdChevronRight className="breadcrumb__chevron" />
              {isLast ? (
                <span className="breadcrumb__current">{crumb.label}</span>
              ) : (
                <Link to={crumb.to} className="breadcrumb__link">{crumb.label}</Link>
              )}
            </React.Fragment>
          );
        })}
        {extra && (
          <>
            <MdChevronRight className="breadcrumb__chevron" />
            <span className="breadcrumb__current">{extra}</span>
          </>
        )}
      </div>
    </nav>
  );
};

export default Breadcrumb;
